import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { cn } from '../utils/cn';
import { getWidthStyle } from '../utils/sizing';

import CaretDown from '../icon/CaretDown';
import * as styles from './Accordion.css';
import type { AccordionTitleElementProps } from './Accordion.types';

const DEFAULTS = {
  padding: '16px 0px 16px 0px',
};

export function AccordionTitleElement(props: AccordionTitleElementProps) {
  const { element, children, attributes, className } = props;
  const { id, width, width_max, padding, mobilePadding, customAttributes } = element.attrs || {};

  return (
    <div
      {...customAttributes}
      data-id={id}
      className={classNames(className, styles.accordionTitle, customAttributes?.className)}
      style={
        {
          '--width': getWidthStyle(width, width_max).width,
          '--max-width': getWidthStyle(width, width_max).maxWidth,
          '--padding': padding ?? DEFAULTS.padding,
          '--mobile-padding': mobilePadding ?? padding ?? DEFAULTS.padding,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
      <CaretDown
        className={cn(
          'h-4 w-4 shrink-0 transition-transform duration-200',
          styles.accordionSvg,
          'accordion-toggle-button',
        )}
        weight="bold"
        size={16}
      />
    </div>
  );
}
